import { Buffer } from "buffer";
import type { AsyncGzipOptions } from "fflate";
import { gunzip as gunzipAsync, gunzipSync, gzip as gzipAsync, gzipSync } from "fflate";
// import promisify from "util.promisify";

export interface FileMetaData {
  name: string;
  type: string;
  size: number;
}

export function getFileMetadata(file: File): FileMetaData {
  // Not supported in Safari for iOS.
  const name = file.name ? file.name : "NOT SUPPORTED";
  // Not supported in Firefox for Android or Opera for Android.
  const type = file.type ? file.type : "NOT SUPPORTED";
  // Unknown cross-browser support.
  const size = file.size ? file.size : -1;

  return {
    name,
    type,
    size,
  };
}

export function readFile(file: File, onProgress: (percent: number) => void, onLoad: (data: ArrayBuffer) => void) {
  const reader = new FileReader();

  reader.addEventListener("load", (event) => {
    // The last progress event might not be at 100%, ensure 100% is returned here
    onProgress(100);

    const result = event.target?.result;
    onLoad(result as ArrayBuffer);
  });

  reader.addEventListener("progress", (event) => {
    if (event.loaded && event.total) {
      const percent = (event.loaded / event.total) * 100;
      onProgress(Math.round(percent));
    }
  });

  reader.readAsArrayBuffer(file);
}

/** literal string, non-encoded data */
export function fromString(data: string): ArrayBuffer {
  return Buffer.from(data);
}

export function fromBase64(data: string): ArrayBuffer {
  return Buffer.from(data, "base64");
}

export function toBase64(data: ArrayBuffer): string {
  return Buffer.from(data).toString("base64");
}

export async function gzip(data: ArrayBuffer): Promise<ArrayBuffer> {
  const bufferSize = data.byteLength;
  if (bufferSize < 1024) {
    // less than 1K (small plain text files)? gzip sync
    return gzipSync(new Uint8Array(data), { mtime: 0 });
  }

  // otherwise gzip async (making use of web workers, dedicated thread)
  // const gzipPromise = promisify<Uint8Array, AsyncGzipOptions, ArrayBuffer>(gzipAsync);
  // return gzipPromise(new Uint8Array(data), { mtime: 0, level: 8 });
}

export async function gunzip(data: ArrayBuffer): Promise<ArrayBuffer> {
  const bufferSize = data.byteLength;
  if (bufferSize < 1024) {
    // (zipped content) less than 1K (small plain text files)? gunzip sync
    return gunzipSync(new Uint8Array(data));
  }

  // otherwise gunzip async (making use of web workers)
  // const gunzipPromise = promisify(gunzipAsync);
  // return gunzipPromise(new Uint8Array(data));
}

export const stringToArrayBuffer = async (str: string) => {
  const decodedOutput = fromBase64(str);
  const unzippedOutput = await gunzip(decodedOutput);
  return unzippedOutput;
};
